(function ($) {
  window.ModifyUtils = {
    $window: null,
    $document: null,
    $body: null,
    promoSlider: null,
    $myaccountOrderHistory: null,
    $inputs: null,
    $faqAccordion: null,
    $faqTabsCaption: null,
    $passwordShow: null,
    $hamburgerMenu: null,
    $mobileNavClose: null,
    $telInput: null,
    $loginRechargeLink: null,
    $customerLoginForm: null,
    $registerForm: null,
    $customeLoginLink: null,
    $selectAddressCountry: null,
    $selectAddressProvince: null,
    $resetPass: null,
    $mealsLinks: null,
    $addressNewButton: null,
    $addressList: null,
    $productSlider: null,
    $logoBar: null,
    $loadMore: null,
    $articleDownload: null,
    checkoutUrl: window.slate.utils.getParameterByName('checkout_url'),
    initNodes: function () {
      this.$window = $(window);
      this.$document = $(document);
      this.$body = $('body');
      this.promoSlider = document.querySelector('#promo-images');
      this.$myaccountOrderHistory = $('.myaccount__order-history');
      this.$inputs = $('.form-group__placeholder input');
      this.$faqAccordion = $('.faq-accordion');
      this.$faqTabsCaption = $('ul.faq-tabs__caption');
      this.$passwordShow = $('.password-show');
      this.$hamburgerMenu = $('.hamburger-menu');
      this.$mobileNavClose = $('.mobile-nav__close');
      this.$telInput = $(".form-group input[type='tel']");
      this.$loginRechargeLink = $('#not_verified .rc_header-settings.rc_title-bar .rc_header-settings__title.rc_title-bar__title a');
      this.$customerLoginForm = $('#CustomerLoginForm');
      this.$registerForm = $('#RegisterForm');
      this.$customeLoginLink = $('#customer_login_link');
      this.$selectAddressCountry = $('select[name="address[country]"]');
      this.$selectAddressProvince = $('select[name="address[province]"]');
      this.$resetPass = $('#reset-pass');
      this.$mealsLinks = $('.list-view-item__group-price a, a.product-card__image-wrapper, a.product-card__title, a.product-card__fw-link');
      this.$addressNewButton = $('#AddressNewButton');
      this.$addressList = $('.address__list');
      this.$productSlider = $('.product-slider');
      this.$logoBar = $('#logo-bar');
      this.$loadMore = $('#load_more');
      this.$articleDownload = $('#article_download');
    },
    initCryptUrl: function () {
      if (typeof window.cryptUrl === 'undefined') {
        var replaceReservedCharacters = window.ModifyHelpers.replaceReservedCharacters;
        window.cryptUrl = function (url, pEmail) {
          var key = pEmail ? theme.resourceKey : theme.apiKey;
          var email = pEmail ? pEmail : theme.customerEmail;
          var phone = theme.appUser ? theme.appUser.phone : null;
          var name = theme.appUser ? theme.appUser.name : null;

          if (typeof CryptoJS === 'undefined') {
            setTimeout(function () {
              return cryptUrl(url);
            }, 500);
          }
          var hash = CryptoJS.HmacSHA256(email, key);
          var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
          var prefix = url.indexOf('?') === -1 ? '?' : '&';
          var returnUrl =
            url +
            prefix +
            'email=' +
            replaceReservedCharacters(email) +
            '&hash=' +
            replaceReservedCharacters(hashInBase64) +
            '&phone=' +
            phone +
            '&name=' +
            name;

          return returnUrl;
        };
      }
    },
    uiInit: function () {
      var $this = this;
      var $self = this;
      if ($this.$myaccountOrderHistory.length && !$('.myaccount__order-history [data-label="Order"]').length) {
        $('.myaccount-header__group .btn:not(#myaccount_dietitian_but):not(.btn--report):not(.btn--no)').hide();
      }

      if ($this.$telInput.length) {
        $this.$telInput.mask('999-999-9999');
      }

      if ($this.$hamburgerMenu.length) {
        $this.$hamburgerMenu.click(function () {
          $('.mobile-nav-wrapper').show();
          $('body, html').addClass('no_scroll');
        });
      }

      if ($this.$mobileNavClose.length) {
        $this.$mobileNavClose.click(function () {
          $('.mobile-nav-wrapper').hide();
          $('body, html').removeClass('no_scroll');
        });
      }

      function changeHandler() {
        var $this = $(this);

        if ($self.detectIE() === false) {
          try {
            $this
              .closest('.form-group__placeholder')
              .toggleClass('filling', !!$(this).val() || $(this).is(':-webkit-autofill') /* was this.matches error */);
          } catch (error) {
            console.error(error);
          }
        } else {
          $this.closest('.form-group__placeholder').toggleClass('filling', !!$(this).val() /* was this.matches error */);
        }
      }

      if ($this.$inputs.length) {
        $this.$inputs.each(changeHandler);
        $this.$window.on('load', function () {
          $this.$inputs.each(changeHandler);
        });
        $this.$inputs.on('change focus blur', changeHandler);
      }

      if ($this.$passwordShow.length) {
        $this.$passwordShow.click(function () {
          var password = $(this).closest('.form-group').find('input');
          if (password.attr('type') == 'password') {
            password.attr('type', 'text');
          } else if (password.attr('type') == 'text') {
            password.attr('type', 'password');
          }
        });
      }

      if ($this.$faqTabsCaption.length) {
        $this.$faqTabsCaption.on('click', 'li:not(.active)', function () {
          $(this)
            .addClass('active')
            .siblings()
            .removeClass('active')
            .closest('div.faq-tabs')
            .find('div.faq-tabs__content')
            .removeClass('active')
            .eq($(this).index())
            .addClass('active');
        });
      }

      if ($this.$faqAccordion.length) {
        $this.$faqAccordion.on('click', '.faq-accordion__question', function () {
          $(this).closest('.faq-accordion').find('.faq-accordion__answer').toggle('slow');
          $(this).closest('.faq-accordion').toggleClass('active');
        });
      }

      // Remove URL param from ReCharge "Please log in" page
      if ($('#not_verified').length && $this.$loginRechargeLink.length) {
        var linkHrefTemp = $this.$loginRechargeLink.attr('href');

        $this.$loginRechargeLink.attr('href', linkHrefTemp.replace(/\?(.*)/i, ''));
      }

      // if ($this.checkoutUrl) {
      //   if ($this.$customerLoginForm.length > 0) {
      //     var no_redir = window.slate.utils.getParameterByName('noredir');

      //     if (!no_redir) {
      //       window.location.href = '/account/register?checkout_url=' + encodeURIComponent($this.checkoutUrl);
      //     }
      //   } else {
      //     if ($this.$registerForm.length > 0) {
      //       var login_url = $this.$customeLoginLink.attr('href') + '?checkout_url=' + encodeURIComponent($this.checkoutUrl) + '&noredir=1';
      //       $this.$customeLoginLink.attr('href', login_url);
      //       var redir = $('<input type="hidden" name="return_to">');
      //       redir.val($this.checkoutUrl);
      //       $this.$registerForm.prepend(redir);
      //     }
      //   }
      // } 

      var hours = new Date().getHours();
      if (hours >= 5 && hours < 12) {
        $('.myaccount-header__greeting-item').hide();
        $('.myaccount-header__greeting-item.morning').show();
      } else if (hours >= 12 && hours < 17) {
        $('.myaccount-header__greeting-item').hide();
        $('.myaccount-header__greeting-item.afternoon').show();
      } else if (hours >= 17 && hours < 21) {
        $('.myaccount-header__greeting-item').hide();
        $('.myaccount-header__greeting-item.evening').show();
      } else {
        $('.myaccount-header__greeting-item').hide();
        $('.myaccount-header__greeting-item.night').show();
      }

      // Blog load more
      if ($this.$loadMore.length) {
        var href = $('.pagination li:last-of-type a').attr('href');

        $this.$loadMore.click(function () {
          if (href) {
            $.get(href, function (data) {
              $('.blog-main__list').append($('.blog-main__list', data).html());
              href = $('.pagination li:last-of-type a', data).attr('href');
              if (!href) {
                $this.loadMore.hide();
              }
            });
          }
        });
      }

      if ($this.$body.attr('data-exception')) {
        var exception = $this.$body.attr('data-exception').split('; ');
        if ($('select[name="address[province]"]').length) {
          for (var item in exception) {
            $('select[name="address[province]"] option[value="' + exception[item] + '"]').remove();
          }
        }
      }
      $this.$selectAddressCountry.find('option:not([value="United States"])').remove();
    },
    promoBlock: function () {
      var $self = this;
      if (!this.promoSlider) return;

      var Promo = {
        slider: null,
        sliderItems: null,
        autoplay: null,
        autoplaySpeed: null,
        activeNumber: 0,
        nextNumber: 1,
        findActiveNumber: function () {
          var _activeNumber = 0;
          this.sliderItems.forEach((item, index) => {
            if (item.className.includes('active')) {
              _activeNumber = index;
            }
          });

          return _activeNumber;
        },
        autoRotateSlides: function () {
          var length = this.sliderItems.length;

          this.activeNumber = this.findActiveNumber();
          this.nextNumber = this.activeNumber + 1 >= length ? 0 : this.activeNumber + 1;
          this.sliderItems[this.activeNumber].classList.remove('active');
          this.sliderItems[this.nextNumber].classList.add('active');
        },
        play: function () {
          clearInterval(this.autoplay);
          this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
        },
        init: function () {
          this.slider = $self.promoSlider;
          this.sliderItems = document.querySelectorAll('.promo-section__images-item');
          this.autoplaySpeed = parseInt(this.slider.dataset.speed);
          this.play();
        },
      };

      Promo.init();
    },
    resourcesInit: function () {
      var $this = this;
      var $resourceDownloadButton = $('#resource-download');

      if ($this.$articleDownload.length) {
        $this.$articleDownload.on('click', function () {
          var $btn = $(this);
          var btnData = {
            name: $btn.attr('data-name'),
            email: $btn.attr('data-email'),
            title: $btn.attr('data-title'),
            url: $btn.attr('href'),
          };
          if (btnData.url && btnData.email && btnData.name) {
            $.ajax(cryptUrl('/tools/softserve/api/resources/1', btnData.email), {
              method: 'POST',
              dataType: 'json',
              data: JSON.stringify(btnData),
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              error: function (jqXHR, textStatus, errorThrown) {
                console.log(btnData, jqXHR, textStatus, errorThrown);
                ModifyHealth.Sentry.captureException(errorThrown);
              },
            });
          }
        });
      }

      var $resourceDownloadForm = $resourceDownloadButton.closest('form');

      /**
       * Sends additional ajax request before submit form.
       *
       * @param {Event} event
       */
      var resourceDownloadFormSubmit = function (event) {
        event.preventDefault();

        var formData = {
          name: $resourceDownloadForm.find('input[name="contact[name]"]').val(),
          email: $resourceDownloadForm.find('input[name="contact[email]"]').val(),
          title: $resourceDownloadForm.find('input[name="contact[title]"]').val(),
          url: $resourceDownloadForm.find('input[name="contact[url]"]').val(),
          imgUrl: $resourceDownloadForm.find('input[name="contact[imgUrl]"]').val(),
        };

        if (formData.name && formData.email && formData.url) {
          $.ajax(cryptUrl('/tools/softserve/api/resources/0', formData.email), {
            method: 'POST',
            dataType: 'json',
            data: JSON.stringify(formData),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            success: function (res, textStatus, jqXHR) {
              // todo: show some message (email has been sent)
              if (jqXHR.status == 204) {
                // Remove our handler, to submit the form in the default way.
                $resourceDownloadForm.off('submit', resourceDownloadFormSubmit);
                $resourceDownloadForm.submit();
                // Add handler when form is submitted (there could be other handlers such validators, etc.)
                $resourceDownloadForm.one('submit', resourceDownloadFormSubmit);
              } else {
                $('.contact-form__successful-send').show();
                $resourceDownloadForm.find('input[name="contact[name]"]').val('').trigger('change');
                $resourceDownloadForm.find('input[name="contact[email]"]').val('').trigger('change');
              }
            },
          });
        }
      };

      if ($resourceDownloadForm.length) {
        $resourceDownloadForm.on('submit', resourceDownloadFormSubmit);
      }

      $('#not_download').on('click', function () {
        $('.resource-form__error').show();
      });
    },
    billingCountry: function () {
      var $this = this;
      $('#billing_country').find('option:not([value="United States"])').remove();
      if ($this.$body.attr('data-exception')) {
        var exception = $('body').attr('data-exception').split('; ');
        if ($('#billing_province_state_selector').length) {
          for (var item in exception) {
            $('#billing_province_state_selector  option[value="' + exception[item] + '"]').remove();
          }
        }
        if ($('#shipping_province_state_selector').length) {
          for (var _item in exception) {
            $('#shipping_province_state_selector  option[value="' + exception[_item] + '"]').remove();
          }
        }
      }
    },
    getCookie: function (name) {
      var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookie: function (name, value, options) {
      options = options || {};
      options.path = '/';
      var expires = options.expires;

      if (typeof expires == 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;

      for (var propName in options) {
        updatedCookie += '; ' + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
      document.cookie = updatedCookie;
    },
    clearLocalStorageCartAndConstructorData: function () {
      var currentDateObj = new Date();
      var dayOfTheWeek = currentDateObj.getDay();
      var thisWeekSunday = currentDateObj;
      var hoursOffset = thisWeekSunday.getTimezoneOffset() / 60 - 4;
      var hours = thisWeekSunday.getHours() + hoursOffset;
      var cartCookie = this.getCookie('cart');

      if (typeof cartCookie === 'undefined') {
        return;
      }

      if (dayOfTheWeek === 1 && hours < 12) {
        thisWeekSunday.setHours(0);
        thisWeekSunday.setMinutes(59);
        thisWeekSunday.setSeconds(59);
        thisWeekSunday.setHours(thisWeekSunday.getHours() - hoursOffset + 11);
      } else {
        thisWeekSunday.setDate(thisWeekSunday.getDate() - thisWeekSunday.getDay() + (thisWeekSunday.getDay() === 0 ? -6 : 1) + 6);

        thisWeekSunday.setHours(23);
        thisWeekSunday.setMinutes(59);
        thisWeekSunday.setSeconds(59);
        thisWeekSunday.setHours(thisWeekSunday.getHours() - hoursOffset + 12);
      }

      this.setCookie('cart', cartCookie, {
        secure: false,
        expires: thisWeekSunday,
      });
    },
    //Adjust header top margin according to the top bar height
    adjustTopBar: function () {
      var $bar = $('#announcement-bar-message'),
        $header = $('#header');

      if (!$bar.length && !$header.length) return;

      $header.css({
        top: $bar.outerHeight(),
      });
    },
    checkUrlParams: function () {
      if (!$('#Contact_article-form').length) return;
      if (window.location.search.includes('form_type=customer')) {
        $('.contact-form__successful-send').show();
      }
    },
    initHealthieERM: function () {
      // Healthie ERM
      $('#myaccount_orders_but').click(function () {
        $('#myaccount_orders').show();
        $('#myaccount_dietitian').hide();
        $('#myaccount_dietitian_but').show();
        $('#myaccount_orders_but').hide();
        $('.myaccount__account-details').show();
      });
      $('#myaccount_dietitian_but').click(function () {
        $('#myaccount_orders').hide();
        $('#myaccount_dietitian').show();
        $('#myaccount_dietitian_but').hide();
        $('#myaccount_orders_but').show();
        $('.myaccount__account-details').hide();
      });
      var show_healthie = parseInt(window.slate.utils.getParameterByName('show_healthie'));
      if (show_healthie == '1') {
        $('#myaccount_orders').hide();
        $('#account-settings').hide();
        $('.myaccount-header').hide();
        $('#myaccount_dietitian').show();
        $('#myaccount_dietitian_but').hide();
        $('#myaccount_orders_but').show();
        $('.myaccount__account-details').hide();
      }
    },
    initSliders: function () {
      var $this = this;

      if ($this.$productSlider.length) {
        $this.$productSlider.slick({
          dots: true,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }

      if ($this.$logoBar.length) {
        $this.$logoBar.slick({
          dots: true,
          infinite: true,
          speed: 3500,
          slidesToShow: 5,
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 400,
          arrows: false,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    },
    toggleAddAddressButton: function () {
      var $this = this;
      if (!$this.$addressList.length) return;

      if (!$('.address__list li').length) {
        $this.$addressNewButton.show();
      }
    },
    editProgressbarLinks: function () {
      if (localStorage.getItem('modifyConstructorStorage') === null) return;
      var modifyConstructorStorage = JSON.parse(localStorage.getItem('modifyConstructorStorage'));

      if ($('.product__stage.step-constructor').length && typeof modifyConstructorStorage.configPageUrl !== 'undefined') {
        $('.product__stage-item:nth-child(2) a').off('click');
        $('.product__stage-item:nth-child(2) a').attr('href', modifyConstructorStorage.configPageUrl);
      }
    },
    dietClick: function () {
      var $dietLink = $('.diet-route');

      if (!$dietLink.length) return;

      $dietLink.on('click', function (e) {
        e.preventDefault();

        var modifyConstructorStorage;
        var href = $(this).attr('href');

        var dietName = $(this).closest('article[data-diet]').attr('data-diet');

        if (localStorage.getItem('modifyConstructorStorage') !== null) {
          modifyConstructorStorage = JSON.parse(localStorage.getItem('modifyConstructorStorage'));
        } else {
          modifyConstructorStorage = {
            selectedDiet: '',
          };
        }

        modifyConstructorStorage.selectedDiet = dietName;

        localStorage.setItem('modifyConstructorStorage', JSON.stringify(modifyConstructorStorage));

        window.location.href = href;
      });
    },
    detectIE: function () {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }
      return;
    },
    checkForCustomerSuscription: function () {
      var $this = this;
      if (!theme.customerId || !$this.$mealsLinks.length) return;
      $.ajax(cryptUrl('/tools/softserve/api/reports/0/customers/' + theme.customerId), {
        method: 'GET',
        dataType: 'json',
        success: function (data, _textStatus, jqXHR) {
          if (jqXHR.status !== 200) return;

          if (data.tags.includes('Active Subscriber')) {
            $this.$mealsLinks.click(function (e) {
              e.preventDefault();
              var url = $(this).attr('href');
              $('.bv-meal-url').attr('href', url);
              MicroModal.show('already-subscriber-modal');
              return;
            });
          }
        },
      });
    },
    initEventListeners: function () {
      var $this = this;
      $this.$window.on('resize', function () {
        $this.adjustTopBar();
      });

      $this.$document.scroll(function () {
        if ($(this).scrollTop() > 43) {
          $('.header, .product-nav').addClass('fixed');
        } else {
          $('.header, .product-nav').removeClass('fixed');
        }
      });

      if ($this.$resetPass.length) {
        $this.$resetPass.on('click', function () {
          $.ajax($(this).attr('href')).done(function () {
            window.location.href = '/pages/reset-password';
          });
          return;
        });
      }
    },
    init: function () {
      var $this = this;

      $this.initNodes();
      $this.initCryptUrl();
      $this.initEventListeners();

      $this.$document.ready(function () {
        $this.checkForCustomerSuscription();
        $this.dietClick();
        $this.initSliders();
        $this.editProgressbarLinks();
        $this.toggleAddAddressButton();
        $this.initHealthieERM();
        $this.adjustTopBar();
        $this.checkUrlParams();
        $this.resourcesInit();
        $this.promoBlock();
        $this.uiInit();
      });

      $this.$window.on('load', function () {
        $this.billingCountry();

        setTimeout(function () {
          $this.clearLocalStorageCartAndConstructorData();
        }, 300);
      });
    },
  };

  window.ModifyUtils.init();
})(jQuery);
